/* eslint-disable no-process-env */

export const APP_CONFIG = {
  appVersion: process.env.REACT_APP_VERSION,
  appName: process.env.REACT_APP_NAME,
  env: process.env.REACT_APP_ENVIRONMENT,
  messageInterval: Number(process.env.REACT_APP_MESSAGE_INTERVAL),

  apiVersion: process.env.REACT_APP_API_VERSION,
  apiUrl: process.env.REACT_APP_API_URL,
  enduserPrefix: process.env.REACT_APP_API_ENDUSER_PREFIX,
  mockUrl: 'https://edward-dev-api.etn.cz',

  docUrl: `${process.env.PUBLIC_URL}/doc`,
  protocol: process.env.REACT_APP_PROTOCOL,
  domain: process.env.REACT_APP_DOMAIN,
  kcAuth: process.env.REACT_APP_KC_AUTHORIZATION_ENDPOINT,
  loginExpiringTimeout: Number(process.env.REACT_APP_LOGIN_EXPIRING),
  sessionExpiringTimeout: Number(process.env.REACT_APP_SESSION_EXPIRING),
  sessionExpiredTimeout: Number(process.env.REACT_APP_SESSION_EXPIRED),

  uiShowVersion: process.env.REACT_APP_SHOW_VERSION === 'true',
  uiShowVersionClient: process.env.REACT_APP_SHOW_VERSION_CLIENT === 'true',
  uiSwitchTabs: process.env.REACT_APP_SWITCH_TABS === 'true',
  uiI18nDebug: process.env.REACT_APP_I18N_DEBUG === 'true',

  pdfUseMockData: process.env.REACT_APP_PDF_USE_MOCK_DATA === 'true',
  gaTrackingId: process.env.REACT_APP_GA_TRACKING_ID,
  debugPdfApiCalls: process.env.REACT_APP_DEBUG_PDF_API_CALLS === 'true',
  errorDetails: process.env.REACT_APP_ERROR_DETAILS === 'true',
  kcUserinfo: process.env.REACT_APP_KC_USERINFO === 'true',

  pdfConfig: `${process.env.PUBLIC_URL}/config/pdf.json`,

  extWebsite: process.env.REACT_APP_EXT_WEBSITE,

  commissionsDomain: process.env.REACT_APP_COMMISSIONS_DOMAIN,
  commissionsPath: process.env.REACT_APP_COMMISSIONS_PATH

};
